export const PLAYLISTS_PATH = '/beamonscreen/playlists';

/** One entry of a playlist as returned by `/bos/playlists` (enriched by the server). */
export interface PlaylistItem {
    itemId: string;
    reelId: string;
    version: number;
    versionLabel: string;
    reelName: string;
    /** `published` | `unpublished` | `deleted` — current state of the parent reel. */
    reelStatus: string;
    /** Newest published version of the reel (to offer "update to vN"). */
    latestVersion: number;
    width: number;
    height: number;
    durationMs: number;
    /** The referenced version no longer exists. */
    missing: boolean;
}

/** `BOS-Playlist` document. */
export interface Playlist {
    _id: string;
    companyId: string;
    name: string;
    description: string;
    items: PlaylistItem[];
    revision: number;
    totalDurationMs: number;
    screensCount: number;
    createdBy: string;
    updatedBy: string;
    createdAt: string;
    updatedAt: string;
}

/** Item as sent to the server. */
export interface PlaylistItemInput {
    itemId?: string;
    reelId: string;
    version: number;
}

export interface PlaylistUpsertPayload {
    name?: string;
    description?: string;
    items?: PlaylistItemInput[];
}

export const formatDuration = (ms: number): string => {
    const total = Math.max(0, Math.round(ms / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}` : `${m}:${String(s).padStart(2, '0')}`;
};
